<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <h5><b>{{ "pages.footerPage.contactUs" | translate }}</b></h5>
        <div>
          <h6>{{ "pages.footerPage.+962987654321" | translate }}</h6>
          <h6>{{ "pages.footerPage.ContactEmail" | translate }}</h6>
          <h6>{{ "pages.footerPage.findPOS" | translate }}</h6>
        </div>
      </div>
      <div class="col-md-3">
        <h5><b>{{ "pages.footerPage.customerRervice" | translate }}</b></h5>
        <div>
          <h6>{{ "pages.footerPage.contactUs" | translate }}</h6>
          <h6>{{ "pages.footerPage.service" | translate }}</h6>
          <h6>{{ "pages.footerPage.faq" | translate }}</h6>
        </div>
      </div>
      <div class="col-md-3">
        <h5><b>{{ "pages.footerPage.info" | translate }}</b></h5>
        <div>
          <h6>{{ "pages.footerPage.aboutPos" | translate }}</h6>
          <h6>{{ "pages.footerPage.howToWorkWithUS" | translate }}</h6>
          <h6>{{ "pages.footerPage.privacyPolicy" | translate }}</h6>
          <h6>{{ "pages.footerPage.termAndCondition" | translate }}</h6>
        </div>
      </div>
      <div class="col-md-3">
        <h5><b>{{ "pages.footerPage.newInPos" | translate }}</b></h5>
        <p>{{ "pages.footerPage.infoText" | translate }}</p>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Search">
          <div class="input-group-btn">
            <button class="btn btn-primary" type="submit">
              <span>{{ "pages.footerPage.subscribe" | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid lower-footer">
    {{ "pages.footerPage.aramexPos" | translate }}
  </div>
</footer>

